import React from "react";
import { Field, ErrorMessage } from "formik";
import TextErrors from "./formikTextErrors";
// import { Info } from "@material-ui/icons";
import TooltipComponent from "../Elements/gTooltip";
import styled from "styled-components";
import { ReactComponent as Check } from "../assets/images/tick.svg";
import { ReactComponent as Uncheck } from "../assets/images/untick.svg";

const Div = styled.div`
  color: #000;
  background: transparent;

  & input[type="radio"] {
    display: none;
  }

  .custom svg {
    height: 1.3rem;
    width: 1.3rem;
    vertical-align: middle;
    margin-right: 15px;
    path {
      fill: #ccc;
    }
  }
  input[type="radio"]:checked + label .custom svg {
    path {
      fill: ${({ theme }) => theme.body};
    }
  }

  &.selected {
    background: ${({ theme }) => theme.body};
    color: #fff;
    .icon svg {
      #Artboard {
        stroke: #fff;
      }
      path {
        stroke: #fff;
      }
      #Rectangle,
      #Circle,
      circle#Oval {
        fill: #fff;
      }
    }
  }
  label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 0 5px;
  }
  .icon svg {
    width: 22px;
    height: 22px;
    margin-right: 6px;
  }
`;

function radioButton(props) {
  const {
    label,
    name,
    options,
    selected,
    key_title,
    style,
    icons,
    key_value,
    ...rest
  } = props;
  return (
    <div className="form-control" style={Object.assign({}, props.mainStyle)}>
      {label ? (
        <label
          style={Object.assign(
            {},
            {
              fontSize: "0.98rem",
              color: "#333",
              marginBottom: "5px",
            },
            props.mainLabelStyle
          )}
        >
          {label}
          {props.type === "variant" && props.isRequired === true ? "*" : ""}
        </label>
      ) : (
        ""
      )}
      <Field name={name} {...rest}>
        {({ field }) => {
          return options.map((option, index) => {
            return (
              <Div
                key={index}
                className={selected === option[key_value] ? "selected" : ""}
                style={Object.assign(
                  {},
                  {
                    display: "inline-block",
                  },
                  props.divstyle
                )}
              >
                <input
                  type="radio"
                  id={name + "_option_" + option[key_value]}
                  {...field}
                  value={option[key_value]}
                  checked={field.value == option[key_value]}
                  style={style}
                />
                <label
                  style={Object.assign(
                    {},
                    {
                      color: selected == option[key_value] ? "#fff" : "#000",
                    },
                    props.labelStyle
                  )}
                  htmlFor={name + "_option_" + option[key_value]}
                >
                  {props.custom === true && (
                    <span className="custom">
                      {field.value == option[key_value] ? (
                        <span>
                          <Check style={{ fontSize: "1rem" }} />
                        </span>
                      ) : (
                        <span>
                          <Uncheck style={{ fontSize: "1rem" }} />
                          {/* <img src={Tick} alt="Check" htmlFor={"check_" + option[key_title]} /> */}
                        </span>
                      )}
                    </span>
                  )}

                  {option[key_title]}

                  {option.tooltipValue ? (
                    <TooltipComponent
                      title={option.tooltipValue}
                      position="bottom"
                      id={option[key_title]}
                    >
                      {/* <Info fontSize="small" /> */}
                    </TooltipComponent>
                  ) : (
                    ""
                  )}
                </label>
              </Div>
            );
          });
        }}
      </Field>
      <ErrorMessage name={name} component={TextErrors} />
    </div>
  );
}

export default radioButton;
